import Vue from 'vue';
import moment from 'moment';
Vue.filter('convertDateITime', function (value) {
  return moment(value).format('HH:MM')
});
